import { _ as e } from "../internals/export.js";
import { g as r } from "../internals/global.js";
import { d as t } from "../internals/define-built-in-accessor.js";
import { d as l } from "../internals/descriptors.js";
var s = TypeError,
  i = Object.defineProperty,
  o = r.self !== r;
try {
  if (l) {
    var n = Object.getOwnPropertyDescriptor(r, "self");
    !o && n && n.get && n.enumerable || t(r, "self", {
      get: function get() {
        return r;
      },
      set: function set(e) {
        if (this !== r) throw s("Illegal invocation");
        i(r, "self", {
          value: e,
          writable: !0,
          configurable: !0,
          enumerable: !0
        });
      },
      configurable: !0,
      enumerable: !0
    });
  } else e({
    global: !0,
    simple: !0,
    forced: o
  }, {
    self: r
  });
} catch (e) {}